export default [
  {
    path: '/video/list',
    name: 'video-list',
    component: () => import('@/views/video/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Video List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Video' }, { title: 'Video List', active: true }],
      permissions: ['video_list']
    }
  }
]
